import { Dropdown } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';

const Sidebar = () => {
    const location = useLocation();

    // Helper function to check active routes
    const isActive = (path: string) => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    const isAnyActive = (paths: string[]) => {
        return paths.some(path =>
            location.pathname === path || location.pathname.startsWith(path + '/')
        );
    };

    const plansPaths = [
        '/billing-subscription',
        '/transactions',
        '/subscription',
        '/invoice',
        '/payment-history'
    ];

    // Added paths for the Affiliate Program dropdown
    const affiliatePaths = [
        '/affiliate-program/dashboard',
        '/affiliate-program/account',
        '/affiliate-program/commission',
        '/affiliate-program/payout',
        '/affiliate-program/report'
    ];

    // Nav items configuration
    const navItems = [
        { path: '/dashboard', label: 'Dashboard', icon: 'ri-home-smile-line' },
        { path: '/organizations-partner', label: 'Organizations / Partner', icon: 'ri-community-line' },
        // { path: '/users', label: 'Users', icon: 'ri-group-line' },
        { path: '/customers-and-users', label: 'Users & Customers ', icon: 'ri-group-line' },
        { path: '/white-label', label: 'White Label', icon: 'ri-layout-masonry-line' },
        { path: '/pricing-studio', label: 'Pricing Studio', icon: 'ri-price-tag-3-line' },
        { path: '/plans-pricing', label: 'Sales', icon: 'ri-file-list-3-line' },
        { path: '/affiliate-program', label: 'Affiliate Program', icon: 'ri-group-line' },
        { path: '/coupons-promo', label: 'Coupons & Promo', icon: 'ri-coupon-line' },
        { path: '/plans-pricing', label: 'Plans & Pricing', icon: 'ri-file-list-3-line' },
        { path: '/qr-code-generator', label: 'QR Code Generator', icon: 'ri-file-list-3-line' },
        { path: '/knowledge-base', label: 'Knowledge Base', icon: 'ri-book-open-line' },
        { path: '/meta-pricing', label: 'Meta Pricing', icon: 'ri-money-dollar-circle-line' },
    ];

    return (
        <div className="hk-menu">
            <div className='menu-header'>
                <a className="navbar-brand" href="index.html">
                    <img className="brand-img w-sm-105p" src="/logo.png" alt="brand" />
                </a>
            </div>
            <div data-simplebar className="nicescroll-bar">
                <div className="menu-content-wrap">
                    <div className="menu-group">
                        <ul className="navbar-nav flex-column">
                            {navItems.map((item) => {
                                if (item.label === 'Sales') {
                                    return (
                                        <li key={item.label} className={`nav-item ${isAnyActive(plansPaths) ? 'active' : ''}`}>
                                            <a
                                                className={`nav-link ${isAnyActive(plansPaths) ? '' : 'collapsed'}`}
                                                href="javascript:void(0);"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#dash_scrumboard"
                                                aria-expanded={isAnyActive(plansPaths)}
                                            >
                                                <span className="nav-icon-wrap">
                                                    <i className={item.icon}></i>
                                                </span>
                                                <span className="nav-link-text">{item.label}</span>
                                            </a>

                                            <ul
                                                id="dash_scrumboard"
                                                className={`nav flex-column nav-children collapse ${isAnyActive(plansPaths) ? 'show' : ''}`}
                                            >
                                                <li className="nav-item">
                                                    <ul className="nav flex-column">
                                                        <li className={`nav-item ${isActive('/billing-subscription') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/billing-subscription">
                                                                <span className="nav-link-text">Billing & Subscription</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/subscription') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/subscription">
                                                                <span className="nav-link-text">Subscription</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/transactions') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/transactions">
                                                                <span className="nav-link-text">Transaction</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/invoice') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/invoice">
                                                                <span className="nav-link-text">Invoice</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/payment-history') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/payment-history">
                                                                <span className="nav-link-text">Payment History</span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    );
                                } else if (item.label === 'Affiliate Program') {
                                    // New dropdown for Affiliate Program
                                    return (
                                        <li key={item.label} className={`nav-item ${isAnyActive(affiliatePaths) ? 'active' : ''}`}>
                                            <a
                                                className={`nav-link ${isAnyActive(affiliatePaths) ? '' : 'collapsed'}`}
                                                href="javascript:void(0);"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#affiliate_dropdown"
                                                aria-expanded={isAnyActive(affiliatePaths)}
                                            >
                                                <span className="nav-icon-wrap">
                                                    <i className={item.icon}></i>
                                                </span>
                                                <span className="nav-link-text">{item.label}</span>
                                            </a>

                                            <ul
                                                id="affiliate_dropdown"
                                                className={`nav flex-column nav-children collapse ${isAnyActive(affiliatePaths) ? 'show' : ''}`}
                                            >
                                                <li className="nav-item">
                                                    <ul className="nav flex-column">
                                                        <li className={`nav-item ${isActive('/affiliate-program/dashboard') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/affiliate-program/dashboard">
                                                                <span className="nav-link-text">Dashboard</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/affiliate-program/account') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/affiliate-program/account">
                                                                <span className="nav-link-text">Affiliate Account</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/affiliate-program/commission') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/affiliate-program/commission">
                                                                <span className="nav-link-text">Commission</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/affiliate-program/payout') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/affiliate-program/payout">
                                                                <span className="nav-link-text">Settlements</span>
                                                            </Link>
                                                        </li>
                                                        <li className={`nav-item ${isActive('/affiliate-program/report') ? 'active' : ''}`}>
                                                            <Link className="nav-link" to="/affiliate-program/report">
                                                                <span className="nav-link-text">Report</span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    );
                                } else {
                                    return (
                                        <li key={item.path} className={`nav-item ${isActive(item.path) ? 'active' : ''}`}>
                                            <Link className="nav-link" to={item.path}>
                                                <span className="nav-icon-wrap">
                                                    <i className={item.icon}></i>
                                                </span>
                                                <span className="nav-link-text">{item.label}</span>
                                            </Link>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;